import { render, staticRenderFns } from "./chevron-left.vue?vue&type=template&id=393852d3&scoped=true&"
import script from "./chevron-left.vue?vue&type=script&lang=js&"
export * from "./chevron-left.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393852d3",
  null
  
)

export default component.exports